import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockIcon from '@material-ui/icons/Lock';
import Typography from '@material-ui/core/Typography';
import {
  specificRiskRed,
  specificRiskRedDna,
  specificRiskNotPurchasedDna,
  specificRiskGreen,
  specificRiskOrange,
  specificRiskRisky,
  specificRiskNotRisky,
  specificRiskModerate,
  specificRiskRiskyDna,
} from 'on_web/assets/imageList';
import { makeStyles } from '@material-ui/core/styles';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';

export default function SpecificRisk(props) {
  const useStyles = makeStyles({
    root: {
      '&:hover': {
        cursor: 'pointer',
      },
    },
  });
  const classes = useStyles();

  return (
    <Box
      display="flex"
      justify="center"
      alignItems="center"
      className={classes.root}
    >
      <Box display="flex">
        <Grid
          container
          direction="column"
          onClick={() => {
            const levelText = props.risk.isDna
              ? props.risk.value === 0
                ? 'Low'
                : props.risk.value === 1
                ? 'Significant'
                : 'High'
              : (props.risk.useScore && props.risk.value > 2) ||
                (props.risk.useScore !== true && props.risk.risksNumber > 0)
              ? 'Risky'
              : 'Not risky';
            const eventText = `${levelText} risk cluster clicked`;
            trackEvent(eventText, 'User clicked on cluster');
            props.onLabelClicked(props.risk.code);
          }}
          style={{
            width: 140,
            marginBottom: '20px',
          }}
        >
          <Grid item>
            <Box display="flex" alignItem="bottom">
              <img
                src={
                  props.risk.isDna
                    ? props.notPurchased
                      ? specificRiskNotPurchasedDna
                      : props.risk.value === 0
                      ? specificRiskGreen
                      : props.risk.value === 1
                      ? specificRiskOrange
                      : specificRiskRedDna
                    : (props.risk.useScore && props.risk.value > 2) ||
                      (props.risk.useScore !== true &&
                        props.risk.risksNumber > 0)
                    ? specificRiskRed
                    : specificRiskGreen
                }
                alt="border"
                width="140px"
              />
            </Box>
          </Grid>
          <Grid item>
            <Box
              style={{
                height: 47,
                backgroundColor: 'White',
                border: '1px Solid #ececec',
              }}
            >
              <Grid container direction="row">
                <Grid
                  item
                  style={{
                    paddingTop: props.risk.label.length > 11 ? 9 : 18,
                    paddingBottom: 18,
                    paddingLeft: 13,
                    maxWidth: 80,
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      fontSize: props.isDesktop ? 12 : 11,
                      color: '#2a343f',
                    }}
                  >
                    {props.risk.label}
                  </Typography>
                </Grid>
                <Grid
                  item
                  style={{
                    paddingRight: 13,
                    paddingTop: 10,
                  }}
                  xs
                >
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    {props.risk.isDna ? (
                      props.notPurchased ? (
                        <LockIcon />
                      ) : props.risk.value === 0 ? (
                        <img src={specificRiskNotRisky} alt="not-risky" />
                      ) : props.risk.value === 1 ? (
                        <img src={specificRiskModerate} alt="moderate-risky" />
                      ) : (
                        <img src={specificRiskRiskyDna} alt="risky" />
                      )
                    ) : (props.risk.useScore && props.risk.value > 2) ||
                      (props.risk.useScore !== true &&
                        props.risk.risksNumber > 0) ? (
                      <img src={specificRiskRisky} alt="risky" />
                    ) : (
                      <img src={specificRiskNotRisky} alt="not-risky" />
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
